/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { layers } from '@atlaskit/theme';

export const Wrapper = styled.div({
  position: 'fixed',
  top: 0,
  width: '100%',
  zIndex: layers.blanket() + 1,
});
